<template>
  <v-card outlined class="mt-2">
    <v-container fluid>
      <v-data-table
        dense
        :headers="headers"
        :items="alerts"
        :loading-text="$t('settings.alerts.alertsLoadingText')"
        :no-data-text="$t('settings.alerts.noAlert')"
        mobile-breakpoint="768"
        item-key="id"
        :loading="loading"
        hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-card-title>{{ $t('settings.alerts.alerts') }}</v-card-title>
            <v-spacer></v-spacer>
            <v-btn
              v-if="alreadySelectedStatus.length < 2"
              color="primary"
              outlined
              @click="$emit('open-new')"
              :disabled="loading"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:item.activate="{ item }">
          <v-switch v-model="item.activate" :disabled="loading"></v-switch>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-row justify="end" class="pr-2">
            <v-btn
              icon
              class="pl-0 pr-0"
              color="primary"
              @click="$emit('edit', item)"
              :disabled="loading"
            >
              <v-icon>mdi-square-edit-outline</v-icon>
            </v-btn>
            <v-btn
              icon
              class="pl-0 pr-0"
              color="error"
              @click="$emit('delete', item)"
              :disabled="loading"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'NotificationSettingsAlertsTable',
  props: {
    alerts: Array,
    loading: Boolean,
    alreadySelectedStatus: Array
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('settings.alerts.name'),
          value: 'name'
        },
        {
          text: this.$t('settings.active'),
          value: 'activate'
        },
        {
          text: '',
          value: 'actions',
          sortable: false
        }
      ]
    }
  }
}
</script>
